var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOgLogoFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 117.096,
    height: 117.053,
    viewBox: "0 0 117.096 117.053",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1",
    "data-name": "Ret\\xE2ngulo 1",
    width: 107.098,
    height: 107.098,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_666",
    "data-name": "Grupo 666",
    transform: "translate(23988.492 13091.231)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1",
    transform: "translate(-24061.369 -12907.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1",
    "data-name": "Caminho 1",
    d: "M86.109-90.528Q75-104.754,78.88-131.367A108.986,108.986,0,0,1,85.325-156.6,36.305,36.305,0,0,1,96-170.733c3.874-3.29,8.61-5.783,17.859-6.947a94.625,94.625,0,0,1,25.582-.015q27.968,4.122,38.144,17.879t6.331,40.149c-2.754,18.906-10.275,32-20.094,39.608s-22.53,10.256-40.6,7.593Q97.21-76.3,86.107-90.529",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_665",
    "data-name": "Grupo 665",
    transform: "translate(-24800.18 -13098.461)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_64",
    "data-name": "Grupo 64",
    transform: "translate(816.675 13.588)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1-2",
    "data-name": "Grupo 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1-2",
    "data-name": "Caminho 1",
    d: "M694.217,1125.647q-11.108-14.225-7.229-40.839a108.985,108.985,0,0,1,6.445-25.232,36.3,36.3,0,0,1,10.68-14.134c3.874-3.29,8.61-5.783,17.859-6.947a94.655,94.655,0,0,1,25.582-.015q27.968,4.123,38.144,17.879t6.331,40.149c-2.754,18.906-10.275,32-20.094,39.608s-22.53,10.256-40.6,7.593q-26.017-3.837-37.12-18.063",
    transform: "translate(-685.984 -1037.621)",
    fill: "#e9443c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65",
    "data-name": "Grupo 65",
    transform: "translate(823.582 52.926)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2",
    "data-name": "Caminho 2",
    d: "M724,1096.023l-3.505-4.775a.382.382,0,0,0-.308-.156h-1.9v4.931H715.68a.252.252,0,0,1-.252-.252v-13.718h5.25c2.92,0,5.037,1.82,5.037,4.508a4.324,4.324,0,0,1-2.456,3.979l3.958,5.482Zm-5.715-7.45h2.393a2,2,0,1,0,0-4h-2.134a.259.259,0,0,0-.259.259Z",
    transform: "translate(-694.524 -1079.423)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3",
    "data-name": "Caminho 3",
    d: "M735.207,1081.784a7,7,0,0,1,5.883,3.027l-1.727,1.421a.382.382,0,0,1-.539-.054,4.6,4.6,0,1,0-3.492,7.521,4.392,4.392,0,0,0,3.684-1.736v-1.142h-3.807a.045.045,0,0,1-.044-.045l.3-2.187a.244.244,0,0,1,.245-.245h6.167v3.38a2.559,2.559,0,0,1-.512,1.531,7.588,7.588,0,0,1-6.156,3,7.242,7.242,0,1,1,0-14.477",
    transform: "translate(-695.206 -1079.41)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4",
    "data-name": "Caminho 4",
    d: "M773.255,1082.053h2.857v13.718a.253.253,0,0,1-.253.253h-2.6Z",
    transform: "translate(-697.731 -1079.423)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5",
    "data-name": "Caminho 5",
    d: "M785.678,1081.784a6.929,6.929,0,0,1,6.16,3.471l-1.844,1.3a.38.38,0,0,1-.526-.089,4.522,4.522,0,0,0-8.3,2.577,4.387,4.387,0,0,0,4.508,4.573,4.539,4.539,0,0,0,3.974-2.307.048.048,0,0,1,.068-.013l2.119,1.495a6.868,6.868,0,0,1-6.181,3.471,7.241,7.241,0,1,1,.021-14.477",
    transform: "translate(-698.007 -1079.408)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6",
    "data-name": "Caminho 6",
    d: "M726.722,1110.125h-5.208l-1.035,2.42h-2.687a.249.249,0,0,1-.229-.35l6.09-13.875h.953l6.223,14.224h-3.07Zm-2.6-6.47-1.682,4.241h3.009a.24.24,0,0,0,.223-.328Z",
    transform: "translate(-694.641 -1080.325)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7",
    "data-name": "Caminho 7",
    d: "M741.128,1112.56l-3.62-4.933h-1.856a.241.241,0,0,0-.24.241v4.691h-2.857v-13.971h5.25c2.921,0,5.037,1.821,5.037,4.509a4.319,4.319,0,0,1-2.356,3.929.093.093,0,0,0-.034.142l3.6,4.981a.258.258,0,0,1-.209.41Zm-5.715-7.549a.1.1,0,0,0,.1.1h2.3a2,2,0,1,0,0-4h-2.393Z",
    transform: "translate(-695.473 -1080.342)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8",
    "data-name": "Caminho 8",
    d: "M746.165,1098.851a.262.262,0,0,1,.262-.262h4.31c4.424-.043,7.684,2.815,7.621,6.943.063,4.044-3.2,7.091-7.621,7.028h-4.572Zm4.551,11.126c2.816,0,4.7-1.757,4.7-4.445,0-2.71-1.842-4.36-4.7-4.36h-1.694v8.544a.261.261,0,0,0,.261.26Z",
    transform: "translate(-696.228 -1080.34)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9",
    "data-name": "Caminho 9",
    d: "M760.847,1098.589h9.4v2.323a.259.259,0,0,1-.259.259H763.7v2.836h4.8v2.434h-4.56a.244.244,0,0,0-.245.245v3.291H770.5v2.582H761.1a.258.258,0,0,1-.258-.259Z",
    transform: "translate(-697.042 -1080.342)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10",
    "data-name": "Caminho 10",
    d: "M715.708,1108.177v-4.4h-7.756a.465.465,0,0,0-.491.406l-.28,2.092a.1.1,0,0,0,.1.1h5.263a.242.242,0,0,1,.243.242v1.716a6.22,6.22,0,0,1-5.437,2.76,6.758,6.758,0,1,1,.182-13.514,6.289,6.289,0,0,1,4.855,2.55.383.383,0,0,0,.544.059l1.779-1.457a.047.047,0,0,0,.008-.064,8.842,8.842,0,0,0-4.877-3.423.048.048,0,0,1-.022-.079,9.031,9.031,0,0,0,2.6-6.478,9.562,9.562,0,0,0-19.122,0,9.321,9.321,0,0,0,6.715,9.013.144.144,0,0,1,.064.237,9.023,9.023,0,0,0-2.471,6.367,9.38,9.38,0,0,0,9.6,9.41,9.725,9.725,0,0,0,8.057-4.1,2.519,2.519,0,0,0,.442-1.436m-19.375-19.526a6.544,6.544,0,1,1,6.54,6.761,6.441,6.441,0,0,1-6.54-6.761",
    transform: "translate(-693.296 -1079.269)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11",
    "data-name": "Caminho 11",
    d: "M752.017,1093.523h-5.208l-1.035,2.421H742.7l6.244-14.225.486-1.1,6.607,15.137a.136.136,0,0,1-.125.191h-2.862Zm-2.758-6.076-1.526,3.848h3.361l-1.523-3.848c-.076-.189-.238-.184-.312,0",
    transform: "translate(-696.037 -1079.345)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12",
    "data-name": "Caminho 12",
    d: "M785.15,1098.574v14.153a.072.072,0,0,1-.071.072h-.243c-.219,0-.609-.011-1.313-.714-.058-.058-7.228-7.727-7.228-7.727-.07-.073-.184-.069-.184.069v8.022a.1.1,0,0,1-.1.1H773.35a.1.1,0,0,1-.1-.1v-14.114l.763-.011a.38.38,0,0,1,.283.119l7.992,8.472v-7.98a.359.359,0,0,1,.36-.36Z",
    transform: "translate(-697.73 -1080.326)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13",
    "data-name": "Caminho 13",
    d: "M770.1,1082.119v14.057a.071.071,0,0,1-.071.071h-.243c-.22,0-.611-.01-1.315-.714-.057-.057-7.227-7.727-7.227-7.727l-.184-.2v8.3a.094.094,0,0,1-.094.1H758.2v-14.212l.765-.01a.377.377,0,0,1,.281.119l7.825,8.3a.1.1,0,0,0,.167-.066v-8.1H770a.1.1,0,0,1,.1.1",
    transform: "translate(-696.897 -1079.408)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOgLogoFrame);
export default __webpack_public_path__ + "static/media/OG_logo_frame.4de483147644c6ec74857dc1af1b807e.svg";
export { ForwardRef as ReactComponent };